import { render, staticRenderFns } from "./ManageClinic.vue?vue&type=template&id=4e035f40"
import script from "./ManageClinic.vue?vue&type=script&lang=js"
export * from "./ManageClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports